/**
 * Converts a hex color string into a 32-bit ARGB integer, compatible with the default color setter in the Rive canvas.
 * @param hex - The hex color string to convert.
 * @param opacity - The opacity of the color, between 0 and 1 (default is 1).
 * @returns The 32-bit integer in ARGB format.
 */
export const hexToRiveColorNumber = (hex: string, opacity = 1): number => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  // Clamp opacity between 0 and 1, then scale to 0-255
  const a = Math.round(Math.min(Math.max(opacity, 0), 1) * 255);

  return ((a << 24) >>> 0) | (r << 16) | (g << 8) | b;
};
